import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import {Divider} from "@mui/material";
import TextWithReadMore from "./TextWithReadMore";
import SocialHandles from "./SocialHandles";
import {Icon} from "./Icon";
import "./Modal.css";
import closeIcon from "./closeIcone/close.png";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  width: "40%",
  padding: "10px 20px 0px 20px",
  border: "none",
};
function isMobile() {
  const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  const tabletWidth = 430;
  
  return viewportWidth <= tabletWidth;
}
export default function CardVelocityFullView(props) {
  const {open, handleClose, cardDetails} = props;
  const positiveURL = "./assets/positiveReviews.png";
  const negativeURL = "./assets/negativeReviews.png";
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Card
        elevation={0}
        sx={{
          borderRadius: "10px",
          backgroundImage: `url(${cardDetails?.positive ? positiveURL : negativeURL})`,
          backgroundOrigin: "center",
          backgroundSize: "cover",
          maxHeight: "90%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          // justifyContent: "space-between",
          ...style,
          "@media (max-width: 768px)": {
            width: "85%",
          },
        }}
      >
        <img src={closeIcon} onClick={handleClose} style={{width:isMobile()?"20px":"30px", cursor:"pointer"}}></img>
        <CardHeader
          action={<b style={{color: "white", fontSize: "12px", position: "absolute", top: "15px", right: "10px"}}>{cardDetails?.curated ? "Curated" : "AI"}</b>}
          title={
            <b
              style={{
                textAlign: "center",
                display: "inherit",
                fontSize: "22px",
                fontFamily: "Inter",
              }}
            >
              {cardDetails?.title}
            </b>
          }
        />
        <div
          className="simple"
          style={{
            maxHeight: "100%",
            overflow: "auto",
            flex: "1",
          }}
        >
          <Typography>{cardDetails?.text}</Typography>
        </div>
        <CardContent
          sx={{
            display: "flex",
            paddingRight: "20px",
            justifyContent: "space-between",
            paddingLeft: "20px",
            gap: "10px",
          }}
        >
          <Box sx={{display: "flex", gap: "10px"}}>
            {cardDetails?.coins?.map?.((coin) => (
              <Box sx={{display: "flex", alignItems: "center", gap: "5px"}}>
                <Icon name={coin.toLowerCase()} url={cardDetails?.icons[coin.toUpperCase()]} />
                <Typography sx={{fontSize: "10px"}}>{coin}</Typography>
              </Box>
            ))}
          </Box>

          <Typography sx={{color: "black", fontWeight: "bold"}}>{cardDetails?.category}</Typography>
        </CardContent>
        <Divider />

        <CardActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "20px",
            paddingLeft: "20px",
            height:isMobile()?"25px":"40px",
            // alignSelf: "flex-end",
          }}
        >
          <SocialHandles icon={cardDetails?.channel} handle={cardDetails?.handle} />
          <Typography sx={{color: cardDetails?.positive ? "#4F9F65" : "#E56262", fontWeight: "bold"}}>
            Score:  {(cardDetails.score*100).toFixed(0)}{"%"}
          </Typography>
          <Typography
            sx={{
              color: "#928F95",
              fontWeight: "bold",
              fontSize: "14px",
              "@media (min-width: 768px)": {
                fontSize: "10px",
              },
            }}
          >
            {cardDetails?.datetime ? new Date(cardDetails?.datetime).toDateString() : new Date().toDateString()}
          </Typography>
        </CardActions>
      </Card>
    </Modal>
  );
}
